import { render } from "./RegistrationPage.vue?vue&type=template&id=3b6faf3d&scoped=true&ts=true"
import script from "./RegistrationPage.vue?vue&type=script&lang=ts"
export * from "./RegistrationPage.vue?vue&type=script&lang=ts"

import "./RegistrationPage.vue?vue&type=style&index=0&id=3b6faf3d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6faf3d"]])

export default __exports__